module.exports = __webpack_public_path__ + "img/fca6-m_en.51bce638.png";